import { Helmet } from "react-helmet-async";
import favlogo from "../Assets/favlogo.png";

function HelmetSEO({ page }) {
  const pages = {
    home: {
      title:
        "Home - Srimathi Manpower Consultancy | Best Maid & Home Care Services in Chennai",
      description:
        "Looking for reliable maids, home caretakers, or hospital attenders in Chennai? Srimathi Manpower Consultancy provides trusted home care, senior citizen care, patient care, and housekeeping services.",
      url: "https://srimathiconsultancy.com/home",
    },
    aboutus: {
      title:
        "About Us - Srimathi Manpower Consultancy | Trusted Manpower Services in Chennai",
      description:
        "Learn more about Srimathi Manpower Consultancy, a leading manpower service provider offering maids, caretakers, and hospital attenders in Chennai.",
      url: "https://srimathiconsultancy.com/aboutus",
    },
    ourservices: {
      title:
        "Our Services - Srimathi Manpower Consultancy | Maids & Caretakers in Chennai",
      description:
        "We offer professional maids, home caretakers, bedridden patient care, hospital attenders, and cleaning services. Book our trusted services in Chennai today.",
      url: "https://srimathiconsultancy.com/ourservices",
    },
    contactus: {
      title: "Contact Us - Srimathi Manpower Consultancy | Get in Touch Today",
      description:
        "Need a home caretaker, maid, or hospital attender? Contact Srimathi Manpower Consultancy for reliable manpower services in Chennai.",
      url: "https://srimathiconsultancy.com/contactus",
    },
    clientform: {
      title:
        "Client Form - Srimathi Manpower Consultancy | Hire a Caregiver or Maid",
      description:
        "Fill out our client form to hire a professional maid, home caretaker, or hospital attender in Chennai.",
      url: "https://srimathiconsultancy.com/clientform",
    },
    candidateform: {
      title: "Candidate Form - Srimathi Manpower Consultancy | Apply for Jobs",
      description:
        "Looking for a job as a maid, hospital attender, or home caretaker? Apply today at Srimathi Manpower Consultancy.",
      url: "https://srimathiconsultancy.com/candidateform",
    },
    privacypolicy: {
      title:
        "Privacy Policy - Srimathi Manpower Consultancy | Your Data is Secure",
      description:
        "Read our privacy policy to understand how we protect your personal data while providing our manpower services.",
      url: "https://srimathiconsultancy.com/privacypolicy",
    },
    terms: {
      title: "Terms & Conditions - Srimathi Manpower Consultancy",
      description:
        "Review our terms and conditions for using Srimathi Manpower Consultancy's services, including hiring maids and home caretakers.",
      url: "https://srimathiconsultancy.com/terms",
    },
    agreements: {
      title: "Service Agreements - Srimathi Manpower Consultancy",
      description:
        "Understand our service agreements for hiring maids, caretakers, and home assistants in Chennai.",
      url: "https://srimathiconsultancy.com/agreements",
    },
  };

  const pageData = pages[page] || pages.home;

  return (
    <Helmet>
      {/* ✅ Page Title & Meta Description */}
      <title>{pageData.title}</title>
      <meta name="description" content={pageData.description} />

      {/* ✅ Expanded SEO Keywords for All Search Queries */}
      <meta
        name="keywords"
        content="Srimathi manpower, sri manpower, sri consultancy, srimathi consultancy, manpower agency in Chennai, 
        best manpower consultancy, home care services Chennai, maid hiring Chennai, home nurse Chennai, 
        bedridden patient care, senior citizen care, hospital attender, domestic workers Chennai, 
        patient care at home, 24-hour maid service, cooking services, cleaning services, 
        physiotherapy at home, Alzheimer's patient care, dementia home assistance, Tamil Nadu nursing services, 
        verified maids Chennai, home worker agency, household help Chennai, part-time maids, full-time maid service, 
        emergency home nursing, affordable housekeeping, babysitters Chennai, patient caretaker, elderly care Chennai, 
        stroke rehabilitation, ICU patient home support, Parkinson’s patient care, home assistant hiring, 
        trusted manpower agency Chennai, Sri manpower solutions, Srimathi manpower solutions, home services Chennai, 
        Sri consultancy for maids, Srimathi manpower Chennai, Tamil Nadu home services, senior care at home, 
        home nursing services, post-surgery care, post-operative care, home healthcare Chennai, 
        verified caretakers Chennai, medical home assistant, hospital home care support, best maid agency Tamil Nadu, 
        maid recruitment agency, professional home help, stroke patient home support, household work assistance, 
        reliable manpower Chennai, best manpower services in Tamil Nadu"
      />

      {/* ✅ Open Graph (For Social Media) */}
      <meta property="og:title" content={pageData.title} />
      <meta property="og:description" content={pageData.description} />
      <meta
        property="og:image"
        content="https://srimathiconsultancy.com/images/home-care-services.jpg"
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={pageData.url} />

      {/* ✅ Twitter Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageData.title} />
      <meta name="twitter:description" content={pageData.description} />
      <meta
        name="twitter:image"
        content="https://srimathiconsultancy.com/images/home-care-services.jpg"
      />

      {/* ✅ Canonical URL */}
      <link rel="canonical" href={pageData.url} />

      <link rel="icon" href={favlogo} />
    </Helmet>
  );
}

export default HelmetSEO;
